import Badge from '@/components/atoms/badge';
import Card from '@/components/atoms/card';
import LinkButton from '@/components/atoms/linkButton';
import { Text } from '@/components/atoms/text';

import { getPrettyProductLabel } from './helpers';
import { useScraper } from './state/context';
import { TargetIcon } from './TargetIcon';

import IconChevronDown from '~/svg/IconChevronDown.svg';
import IconOnboarding from '~/svg/IconOnboarding.svg';

export const ScraperHeaderCard = () => {
  const { target, dashboardAction } = useScraper();

  return (
    <Card
      classNames={{
        root: 'border-neutral-N10 flex items-center justify-between border p-6 w-full group-hover/popover:border-neutral-N99 group-data-[state=open]/popover:border-primary-P99',
      }}
      data-tracker-context='targets-dropdown'
      hasHoverEffect={true}
    >
      <div className='pointer-events-none flex flex-col gap-1'>
        <Badge size='s' colors='neutral-N99'>
          Target Group
        </Badge>
        <div className='flex items-center gap-x-2'>
          <TargetIcon target={target} />
          <Text
            variant='button-text-m'
            classNames={{ wrapper: 'font-serif text-neutral-N94' }}
          >
            {target.label}
          </Text>
          <Badge
            size='s'
            colors='neutral-N99'
            variant='outlined'
            classNames={{ root: 'pointer-events-none' }}
          >
            {getPrettyProductLabel(target)?.replace(/_/g, ' ')}
          </Badge>
          <IconChevronDown className='group-data-[state=closed]/popover:rotate-0 group-data-[state=open]/popover:rotate-180 group-data-[state=open]/popover:transition' />
        </div>
      </div>
      {dashboardAction?.url && (
        <LinkButton
          href={dashboardAction.url}
          leftSection={<IconOnboarding />}
          classNames={{ root: 'hidden md:flex' }}
          onClick={(e) => e.stopPropagation()}
          onMouseOver={(e) => e.stopPropagation()}
        >
          {dashboardAction.text ?? 'Start free trial'}
        </LinkButton>
      )}
    </Card>
  );
};
